var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9116 0.2436L13.908 6.00509L20.6063 6.92921C20.7797 6.95359 20.9235 7.06878 20.9775 7.22653C21.0315 7.38428 20.9864 7.55735 20.861 7.67325L16.0151 12.157L17.1592 18.4893C17.1893 18.6526 17.1186 18.8179 16.9769 18.9155C16.8353 19.0131 16.6473 19.026 16.4922 18.9488L10.5007 15.9597L4.50919 18.9497C4.3542 19.0271 4.16609 19.0144 4.02434 18.9169C3.88258 18.8193 3.8119 18.6539 3.84215 18.4906L4.9863 12.157L0.138953 7.67325C0.0135841 7.55735 -0.0315455 7.38428 0.0224676 7.22653C0.0764806 7.06878 0.220312 6.95359 0.393716 6.92921L7.09197 6.00509L10.0898 0.2436C10.1661 0.0946227 10.3257 0 10.5007 0C10.6757 0 10.8353 0.0946227 10.9116 0.2436Z",
    fill: "#FCAD38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.67d8589ddc78a5293f1bec238ec7712f.svg";
export { ForwardRef as ReactComponent };